import { device } from 'components/styles/MediaQuery';
import styled from 'styled-components';

export const ScAdditionalDataFormContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 32px;
  width: 100%;

  & > .header {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    font-weight: 700;
    text-align: center;
    letter-spacing: 0.01em;

    & > .title {
      font-size: 22px;
      line-height: 1.27;
      color: ${({ theme }) => theme.whiteColor};
    }

    & > .slogan {
      font-size: 16px;
      line-height: 1.75;
      color: ${({ theme }) => theme.grayColor1};
    }
  }

  & > .fields-container {
    display: flex;
    flex-direction: column;
    row-gap: 16px;
  }

  & > .submit-btn-container {
    display: flex;
    justify-content: center;
  }

  & .country-info-msg {
    padding: 0 16px;
    margin: 4px 0;
    font-size: 12px;
    line-height: 18px;

    & > span {
      cursor: pointer;
      text-decoration: underline;
      color: ${({ theme }) => theme.greenColor};
    }
  }

  @media (${device.mobileS}) {
    row-gap: 16px;

    & > .header {
      & > .title {
        font-size: 18px;
        line-height: 1.33;
      }

      & > .slogan {
        font-size: 14px;
        line-height: 1.43;
      }
    }
  }
`;
